import { paymentActionTypes } from '@Actions/paymentOutgoingActions';

const PaymentOutgoingReducers = (state = { }, action) => {
  switch (action.type) {
  case paymentActionTypes.GET_PAYMENTS_OUTGOING.LOADING: {
    const { getPaymentsOutgoingLoading } = action;
    return {
      ...state,
      getPaymentsOutgoingLoading,
    };
  }
  case paymentActionTypes.GET_PAYMENTS_OUTGOING.SUCCESS: {
    const { paymentOutgoing } = action;
    return {
      ...state,
      paymentOutgoing,
    };
  }
  case paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.LOADING: {
    const { getApprovedOnlinePaymentsLoading } = action;
    return {
      ...state,
      getApprovedOnlinePaymentsLoading,
    };
  }
  case paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.SUCCESS: {
    const { approvedPayments } = action;
    return {
      ...state,
      approvedPayments,
    };
  }
  case paymentActionTypes.CREATE_PAYMENTS_OUTGOING.LOADING: {
    const { createPaymentsOutgoingLoading } = action;
    return {
      ...state,
      createPaymentsOutgoingLoading,
    };
  }
  case paymentActionTypes.UPDATE_PAYMENTS_OUTGOING.LOADING: {
    const { updatePaymentsOutgoingLoading } = action;
    return {
      ...state,
      updatePaymentsOutgoingLoading,
    };
  }
  case paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.LOADING: {
    const { updatePaymentsOutgoingStatusLoading } = action;
    return {
      ...state,
      updatePaymentsOutgoingStatusLoading,
    };
  }
  case paymentActionTypes.DELETE_PAYMENT_OUTGOING.LOADING: {
    const { deletePaymentOutgoingLoading } = action;
    return {
      ...state,
      deletePaymentOutgoingLoading,
    };
  }
  case paymentActionTypes.CREATE_AND_LINK_PAYMENT.LOADING: {
    const { createAndLinkPaymentLoading } = action;
    return {
      ...state,
      createAndLinkPaymentLoading,
    };
  }
  case paymentActionTypes.LINK_PAYMENT.LOADING: {
    const { linkPaymentLoading } = action;
    return {
      ...state,
      linkPaymentLoading,
    };
  }
  case paymentActionTypes.UNLINK_PAYMENT.LOADING: {
    const { unLinkPaymentLoading } = action;
    return {
      ...state,
      unLinkPaymentLoading,
    };
  }
  case paymentActionTypes.UPDATE_PAYMENT_OUTGOING_WORKFLOW.LOADING: {
    const { updatePaymentOutgoingWorkflowLoading } = action;
    return {
      ...state,
      updatePaymentOutgoingWorkflowLoading,
    };
  }
  case paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.LOADING: {
    const { getPaymentOutgoingByIdLoading } = action;
    return {
      ...state,
      getPaymentOutgoingByIdLoading,
    };
  }
  case paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.SUCCESS: {
    const { selectedPaymentOutgoing } = action;
    return {
      ...state,
      selectedPaymentOutgoing,
    };
  }
  // UNLINKING PO ADVANCE PAYMENT
  case paymentActionTypes.UNLINK_PO_ADVANCE_PAYMENT.LOADING: {
    const { unlinkPOAdvancePaymentLoading } = action;
    return {
      ...state,
      unlinkPOAdvancePaymentLoading,
    };
  }

  case paymentActionTypes.DOWNLOAD_PAYMENT_OUTGOING.LOADING: {
    const { downloadPaymentOutgoingLoading } = action;
    return {
      ...state,
      downloadPaymentOutgoingLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default PaymentOutgoingReducers;
